import { SELECTOR } from "../types/element/constants";

type Parent = ParentNode | HTMLElement | Document;

export const suggestLayer = (parent?: Parent) => SquirrelElement.getElement<HTMLDivElement>(SELECTOR.LAYER, parent);

/*                                              */
/*                                                                             */
/*                                              */
/*                                                                           */
/*                                               */
/*                                                                            */
/*                                                  */
/*                                                                               */
//
/*                                               */
/*                                                                             */
/*                                                                              */
/*                                                                      */
/*                                                                        */
/*                                                           */
/*                                                                                           */
/*   */

export class SquirrelElement {
  static getElement<E extends HTMLElement>(selector: SELECTOR, parent?: Parent): E {
    const _parent = !parent ? document : parent;
    return _parent.querySelector(selector) as E;
  }

  static getElements<E extends HTMLElement>(selector: SELECTOR, parent?: Parent): E[] {
    const _parent = !parent ? document : parent;
    return Array.from<E>(_parent.querySelectorAll(selector));
  }
}
